import { render } from "./whyChooseUs.vue?vue&type=template&id=441f0a78"
import script from "../js/why-choose-us.js?vue&type=script&lang=js&external"
export * from "../js/why-choose-us.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__